<template>
  <Panel
    class="intro-y"
    :title="$t('text.loanHistory')"
    :btnName="$t('text.loanSeeAll')"
    @click="onClick"
  >
    <div
      v-for="(item, index) in loan.histories"
      :key="index"
      :class="['flex flex-col sm:flex-row', { 'mt-5': index > 0 }]"
    >
      <div class="mr-auto ">
        <p>{{ item.status | loanStatusToVerb }}</p>
        <p v-if="item.paidAmount">{{ item.paidAmount | currency }}</p>
      </div>
      <p class="font-medium">{{ item.createdAt | momentDate('YYYY-MM-DD HH:mm:ss') }}</p>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/ui/Panel';
import humps from 'humps';

export default {
  props: {
    loan: Object,
  },
  components: { Panel },
  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
    onClick() {
      this.$router.push({
        name: 'CustomerDetailsLoanHistory',
        params: { customerId: this.loan.user.id },
      });
    },
  },
};
</script>
